import { ModalComposition } from '@codeleap/web'
import { textVariant } from './Text'
import { StyleRegistry } from '../styles'
import { createStyles } from '@codeleap/styles'

const createModalVariant = createStyles<ModalComposition>

export const ModalStyles = {
  default: createModalVariant((theme) => ({
    wrapper: {
      width: '100vw',
      minHeight: '100svh',
      position: 'fixed',
      ...theme.presets.whole,
      zIndex: 999,
      transition: 'visibility 0.2s ease',
      animation: 'fadeIn 0.2s ease-in-out',
    },
    'wrapper:hidden': {
      visibility: 'hidden',
      pointerEvents: 'none',
    },
    'wrapper:visible': {
      visibility: 'visible',
      pointerEvents: 'auto',
    },
    innerWrapper: {
      ...theme.presets.relative,
      ...theme.presets.justifyCenter,
      ...theme.presets.alignStart,
      minWidth: '100vw',
      width: '100vw',
    },
    backdropPressable: {
      ...theme.presets.whole,
      ...theme.presets.absolute,
      zIndex: 2,
      cursor: 'pointer',
    },
    backdrop: {
      ...theme.presets.absolute,
      ...theme.presets.whole,
      backgroundColor: theme.baseColors.neutralSolid1000,
      zIndex: -1,
      minHeight: '100svh',
      transition: 'opacity 0.2s ease-in-out',
      animation: 'opacity 0.2s ease-in-out',
    },
    'backdrop:visible': {
      opacity: 0.5,
    },
    'backdrop:hidden': {
      opacity: 0,
    },
    box: {
      backgroundColor: theme.baseColors.neutralSolid0,
      maxWidth: `85dvw`,
      borderRadius: theme.radius.custom,
      ...theme.presets.column,
      zIndex: 3,
      ...theme.spacing.padding(3),
      ...theme.presets.relative,
      overflow: 'hidden',
      transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out',
      animation: 'scaleIn 0.2s ease-in-out',

      [theme.media.down('tabletSmall')]: {
        ...theme.spacing.padding(2),
      },
    },
    'box:hidden': {
      opacity: 0,
      transform: `scale(0.8)`,
    },
    'box:visible': {
      transform: `scale(1)`,
    },
    body: {
      ...theme.presets.column,
    },
    header: {
      ...theme.presets.column,
      ...theme.spacing.marginBottom(2),
      ...theme.presets.alignStart,
      ...theme.presets.justifySpaceBetween,
      backgroundColor: theme.baseColors.neutralSolid0,
    },
    titleWrapper: {
      ...theme.presets.relative,
      ...theme.presets.fullWidth,
      ...theme.presets.row,
      ...theme.presets.center,
    },
    title: {
      ...textVariant('h4'),
      color: theme.baseColors.neutralSolid1000,

    },
    description: {
      ...theme.presets.fullWidth,
      textAlign: 'center',
      color: theme.baseColors.neutralSolid800,
      ...theme.spacing.marginTop(1),
      ...textVariant('p1'),
    },
    footer: {
      ...theme.spacing.marginTop(2),
    },
    'closeButtonTouchableWrapper': {
      padding: theme.spacing.value(0),
      width: 'auto',
      height: 'auto',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      borderRadius: 0,
      background: 'transparent',
      ...theme.border({
        width: 0,
        style: 'solid',
        color: 'transparent',
      }),
    },
    closeButtonIcon: {
      color: theme.baseColors.primarySolid300,
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
    },
  })),
  fullscreen: createModalVariant((theme) => ({
    innerWrapper: {
      padding: 0,
      backgroundColor: theme.baseColors.neutralSolid0,
      minHeight: '100lvh',
    },
    box: {
      maxWidth: '100vw',
      width: '100vw',
      minHeight: '100svh',
      borderRadius: 0,
    },
    body: {
      maxWidth: '100vw',
      width: '100%',
    },
  })),
  centered: createModalVariant((theme) => ({
    innerWrapper: {
      ...theme.presets.center,
    },
    // title: {
    //   margin: 'auto',
    // },
  })),
  withScrollContainer: createModalVariant((theme) => ({
    innerWrapper: {
      ...theme.presets.alignStart,
    },
  })),
  'overflow:visible': createModalVariant((theme) => ({
    box: {
      overflow: 'visible',
    },
    body: {
      overflow: 'visible',
    },
  })),
  'box:responsiveness': createModalVariant((theme) => {
    const MAX_BOX_WIDTH = 450

    return {
      box: {
        width: `calc(100vw - ${theme.spacing.value(4)}px)`,
        maxWidth: MAX_BOX_WIDTH,
      },
    }
  }),
  'box:noPadding': createModalVariant((theme) => ({
    box: {
      ...theme.spacing.padding(0),
      [theme.media.down('tabletSmall')]: {
        ...theme.spacing.padding(0),
      },
    },
    closeButtonTouchableWrapper: {
      marginRight: theme.spacing.value(2),
    },
  })),
}

StyleRegistry.registerVariants('Modal', ModalStyles)
